import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-fem-modal',
  templateUrl: './fem-modal.component.html',
  styleUrls: ['./fem-modal.component.scss'],
  standalone: false,
})
export class FemModalComponent {
  @Input() buttonTextKey: 'continue' | 'print_boarding_pass' = 'continue';
  readonly femUrl: string = 'https://www.inm.gob.mx/fem/';

  constructor(public modal: NgbActiveModal) {}

  onContinue(): void {
    this.modal.close('continue');
  }
}
